import { Dropdown, Segmented } from "antd";
import { ShrinkingButton } from "~/components/ShrinkingButton";

export const SegmentedOrDropdown = ({
  items,
  selected,
  setSelected,
  useDropdown,
}: {
  items: string[];
  selected: number;
  setSelected: (index: number) => void;
  useDropdown: boolean;
}) => {
  return useDropdown ? (
    <Dropdown
      menu={{
        items: items.map((str, index) => {
          return {
            key: index.toString(),
            label: <>{str}</>,
          };
        }),
        onClick: ({ key }) => {
          setSelected(Number(key));
        },
      }}
      placement="bottomLeft"
      arrow
    >
      <ShrinkingButton arrow={true} small={true}>
        {items[selected]}
      </ShrinkingButton>
    </Dropdown>
  ) : (
    <Segmented
      options={items}
      onChange={(value) => {
        let index = items.indexOf(value.toString());
        setSelected(index);
      }}
    />
  );
};
